<template>
  <div class="expense-form">
    <img src="@/assets/logo.png" alt="Logo" class="form-logo">
    
    <h1>Transporte sin soporte</h1>
    <form @submit.prevent="submitExpense">

      <div class="form-group">
        <label for="maestroGasto">Maestro Gasto*</label>
        <v-select :options="maestroGasto" v-model="expense.maestroGasto" label="nombreviaje" :reduce="gasto => gasto.id" @search="onGastoSearch" @input="addGasto"/>
      </div>

      <div class="tabs">
        <button :class="{ active: activeTab === 1 }" @click.prevent="activeNewTab">Detalles de Gastos</button>
        <button :class="{ active: activeTab === 2 }" @click.prevent="activeEditTab">Gastos Enviados</button>
      </div>

      <div v-if="activeTab === 2">
          <div class="summary">
            <p>Gastos pendientes: {{ totalSpentEdits }}</p>
            <button type="button" @click="sendEdit">Enviar cambios</button>
          </div>
        
        <div v-for="(gasto, index) in gastossubidos" :key="index" class="gasto-group">
          <h3 @click="toggleCollapseEdit(index)">
            <CircleAlert v-if="gasto.edit" class="icon-edit-true" />
            <Check v-else class="icon-edit-false" />
            Gasto enviado {{ index + 1 }}
            <Plus v-if="gasto.collapsed" class="icon-collapsed" />
            <Minus v-else class="icon-collapsed" />
          </h3>
          <div class="buttons">
            <button type="button" @click="saveEdit(index)">Guardar cambios en Gasto {{ index + 1 }}</button>
          </div>
          

          <div v-if="!gasto.collapsed">
            <div class="form-group date-input-container">
              <label for="fechagasto">Fecha del Gasto*</label>
              <input type="date" v-model="gasto.fechagasto" required />
              <span class="icon">📅</span>
            </div>
            <div class="form-group">
              <label for="lugarsalida">Lugar de Salida*</label>
              <input type="text" v-model="gasto.lugarsalida" required />
            </div>
            <div class="form-group">
              <label for="lugarllegada">Lugar de Llegada*</label>
              <input type="text" v-model="gasto.lugarllegada" required />
            </div>
            <div class="form-group">
              <label for="mediotransporte">Medio de Transporte*</label>
              <v-select :options="mediosTransporte" v-model="gasto.mediotransporte" label="nombre" @search="onTransportMeansSearch" required/>
            </div>
            <div class="form-group">
              <label for="moneda">Moneda*</label>
              <v-select :options="monedas" v-model="gasto.moneda" required label="nombreMoneda" @search="onCurrencySearch"/>
            </div>
            <div class="form-group">
              <label for="mediopago">Medio de Pago*</label>
              <v-select :options="mediosPago" v-model="gasto.mediopago" label="nombre" required @search="onPaymentMeansSearch" />
            </div>
            <div class="form-group">
              <label for="valor">Valor Pagado*</label>
              <input type="number" v-model="gasto.valor" step="0.01" required />
            </div>
            <div class="form-group">
              <label for="observaciones">Observaciones</label>
              <textarea v-model="gasto.observaciones"></textarea>
            </div>
          </div>
          <hr />
        </div>
      </div>

      <div v-if="activeTab === 1">
        <div v-for="(gasto, index) in expense.gastos" :key="index" class="gasto-group">
          <h3 @click="toggleCollapse(index)">
            Gasto de Transporte {{ index + 1 }}
            <Plus v-if="gasto.collapsed" class="icon-collapsed" />
            <Minus v-else class="icon-collapsed" />
          </h3>
          <div class="buttons">
            <button type="button" @click="removeGasto(index)">Eliminar Gasto</button>
          </div>
          
          <div v-if="!gasto.collapsed">
            <div class="form-group date-input-container">
              <label for="fechagasto">Fecha del Gasto*</label>
              <input type="date" v-model="gasto.fechagasto" required />
              <span class="icon">📅</span>
            </div>
            <div class="form-group">
              <label for="lugarsalida">Lugar de Salida*</label>
              <input type="text" v-model="gasto.lugarsalida" required />
            </div>
            <div class="form-group">
              <label for="lugarllegada">Lugar de Llegada*</label>
              <input type="text" v-model="gasto.lugarllegada" required />
            </div>
            <div class="form-group">
              <label for="mediotransporte">Medio de Transporte*</label>
              <v-select :options="mediosTransporte" v-model="gasto.mediotransporte" label="nombre" :reduce="mediotransporte => mediotransporte.id" @search="onTransportMeansSearch" required/>
            </div>
            <div class="form-group">
              <label for="moneda">Moneda*</label>
              <v-select :options="monedas" v-model="gasto.moneda" required label="nombreMoneda" :reduce="moneda => moneda.id" @search="onCurrencySearch"/>
            </div>
            <div class="form-group">
              <label for="mediopago">Medio de Pago*</label>
              <v-select :options="mediosPago" v-model="expense.gastos[index].mediopago" label="nombre" required  :reduce="medioPago => medioPago.id" @search="onPaymentMeansSearch" />
            </div>
            <div class="form-group">
              <label for="valorpagado">Valor Pagado*</label>
              <input type="number" v-model="gasto.valorpagado" step="0.01" required />
            </div>
            <div class="form-group">
              <label for="observaciones">Observaciones</label>
              <textarea v-model="gasto.observaciones"></textarea>
            </div>
          </div>
          <hr />
        </div>
        
        <div class="buttons">
          <button type="button" @click="addGasto">Agregar detalle al gasto</button>
          <button type="submit">Subir gastos</button>
        </div>
        
      </div>

      

    </form>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {updateGCS3, insertarDetalleGCS, selectMaestroGastos, selectMonedas, selectMediosPago, selectMediosTransporte, tokenValidation, editSpents, selectSpentDetailEdit } from '@/api/api';
import { Plus, Minus, Check, CircleAlert } from 'lucide-vue-next'; "lucide-vue-next";

export default {
  name: 'TransporteSinSoporte',
  components: {
    vSelect,
    Plus,
    Minus,
    Check,
    CircleAlert,
  },
  data() {
    return {
      activeTab: 1,
      expense: {
        gastos: [],
        maestroGasto: null,
      },
      maestroGasto: [],
      mediosTransporte: [],
      monedas: [],
      totalCOP: 0.0,
      totalUSD: 0.0,
      mediosPago: [],
      correousuario: '',
      selectedGasto: null,
      gastossubidos: [],
      spentsedits: [],
      tableType: 'tss',
      uploading: false,
    };
  },
  mounted() {
    this.reloadPage();
    this.fecthGastos();
    this.fecthCurrency();
    this.fecthPaymentMeans();
    this.fecthTransportMeans();
  },
  watch: {
    'expense.maestroGasto'() {
      this.fecthExpenses();
    }
  },
  computed: {
    totalSpentEdits() {
      return this.spentsedits.length;
    },
  },
  methods: {
    saveEdit(index) {
      const gastoEditado = this.gastossubidos[index];

      // Verificar si el gasto ya está en la lista de editados
      if (this.spentsedits.length == 0) {
        this.spentsedits.push({ ...gastoEditado });
        this.gastossubidos[index].edit = true;
      } else { 
        let duplicated = false;
        for (let i = 0; i < this.spentsedits.length; i++) {
          if (this.spentsedits[i].iddetallegasto === gastoEditado.iddetallegasto) {
            this.spentsedits[i] = gastoEditado;
            duplicated = true;
            this.gastossubidos[index].edit = true;
            break;
          }          
        }
        if (!duplicated) {
          this.spentsedits.push({ ...gastoEditado });
          this.gastossubidos[index].edit = true;
        }
      }
    },
    async sendEdit() {
      if (this.spentsedits.length == 0) {
        alert("No hay gastos para actualizar");
      } else if (this.checkRequiredEditFields()) {
        alert("Campos obligatorios vacios, revisar")
      } else {
        let dateTimeActual = new Date(Date.now());
        dateTimeActual.setHours(dateTimeActual.getHours() - 5);
        let data = []
        for (const gasto of this.spentsedits) {
          data.push({
            ...gasto,
            fechaactualizacion: dateTimeActual.toISOString(),
          })
        }
        let tableType = this.tableType;
        await editSpents(data, tableType);
        alert("Gastos actualizados");
        this.spentsedits = [];
        this.fecthExpenses();
      }
    },
    async fecthExpenses() {
      try {
        const info = {id: this.expense.maestroGasto, tableType: this.tableType};
        const response = await selectSpentDetailEdit(info);
        this.gastossubidos = response.data.map(gasto => gasto);
      } catch (error) {
        alert("Error al buscar gastos")
      }
    },
    activeNewTab() {
      this.activeTab = 1;
    },
    activeEditTab() {
      this.activeTab = 2;
    },
    calcularTotalesPorMoneda() {
      // Resetear totales antes de sumar
      this.totalCOP = 0.0;
      this.totalUSD = 0.0;

      // Calcular totales según tipo de moneda
      this.expense.gastos.forEach(gasto => {
        if (gasto.moneda === 1) {
          this.totalCOP += parseFloat(gasto.valorpagado || 0.0);
        } else if (gasto.moneda === 2) {
          this.totalUSD += parseFloat(gasto.valorpagado || 0.0);
        }
      });
    },
    async reloadPage() { // Recarga la pagina en caso de que el token haya caducado
      let ValidToken = await tokenValidation();
      try {
        if(typeof(ValidToken.data) == undefined) {
          window.location.reload();
        } else {
          this.correousuario = ValidToken.data;
        }
      } catch (error) {
        console.error("Error al validar token", error);
        window.location.reload();
      }
    },
    resetForm() {
      this.expense = {
        gastos: [],
        maestroGasto: null,
      };
      this.maestroGasto = [];
      this.mediosTransporte = [];
      this.monedas = [];
      this.mediosPago = [];
      this.reloadPage();
      this.fecthGastos();
      this.fecthCurrency();
      this.fecthPaymentMeans();
      this.fecthTransportMeans();
    },
    addGasto() {
        if (!this.expense.maestroGasto) {
          alert("No hay un gasto seleccionado");  
      } else {
        this.expense.gastos.push({
          fechagasto: null,
          lugarsalida: null,
          lugarllegada: null,
          mediotransporte: null,
          moneda: null,
          mediopago: this.mediosPago[0].id,
          valorpagado: 0.0,
          observaciones: null,
          collapsed: false, // Estado de colapso
          responsable: '',
        });
      }
    },
    removeGasto(index) {
      this.expense.gastos.splice(index, 1);
    },
    toggleCollapse(index) {
      this.expense.gastos[index].collapsed = !this.expense.gastos[index].collapsed;
    },
    toggleCollapseEdit(index) {
      this.gastossubidos[index].collapsed = !this.gastossubidos[index].collapsed;
    },
    checkZeroValues() {
      for (const gasto in this.expense.gastos) {
        if (this.expense.gastos[gasto].valorpagado === 0.0) {
          return true
        }
      }
      return false
    },
    async submitExpense() {
      if (!this.expense.maestroGasto || this.expense.gastos.length === 0) {
        alert("No hay datos en el formulario");
      } else if (this.checkZeroValues() === true || this.checkRequiredFields() === true) {
        alert("Campo obligatorios sin llenar (*), revisar antes de enviar")
      } else if (this.uploading) {
        alert("Cargando gastos, espere.")
      } else {
        try {
          this.uploading = true;
          let dateTimeActual = new Date(Date.now());
          dateTimeActual.setHours(dateTimeActual.getHours() - 5);
          this.calcularTotalesPorMoneda();

          let expenseData = {
            ...this.expense,
            totalCOP: this.totalCOP,
            totalUSD: this.totalUSD,
            fechaActualizacion: dateTimeActual.toISOString(),
          };

          // Envía los datos al servidor
        
          await updateGCS3(expenseData);

          for (const gasto of this.expense.gastos) {
            expenseData = {
              ...this.expense,
              title: 3,
              idViaje: this.maestroGasto,
              ...gasto,
              fechacreacion: dateTimeActual.toISOString(),
              fechaActualizacion: dateTimeActual.toISOString(),
            }
            await insertarDetalleGCS(expenseData);
          }
          alert('Gastos subidos con éxito');
          this.resetForm();
          
        } catch (error) {
          console.error('Error al subir los gastos:', error);
        } finally {
          this.uploading = false;
        }
      }
    },
    checkRequiredFields() {
      for (const gasto in this.expense.gastos) {
        if (!this.expense.gastos[gasto].fechagasto|| !this.expense.gastos[gasto].lugarsalida || !this.expense.gastos[gasto].lugarllegada|| !this.expense.gastos[gasto].mediotransporte || !this.expense.gastos[gasto].mediopago  || !this.expense.gastos[gasto].moneda) {
          return true
        }
      }
      return false
    },
    checkRequiredEditFields() {
      for (const gasto in this.spentsedits) {
        if (!this.spentsedits[gasto].fechagasto|| !this.spentsedits[gasto].lugarsalida || !this.spentsedits[gasto].lugarllegada|| !this.spentsedits[gasto].mediotransporte || !this.spentsedits[gasto].mediopago  || !this.spentsedits[gasto].moneda || !this.spentsedits[gasto].valor) {
          return true
        }
      }
      return false
    },
    async fecthGastos(query) {
      try {
        const response = await selectMaestroGastos(query);
        this.maestroGasto = response.data.map(gas => ({
          id: gas.idviaje,
          nombreviaje: gas.nombreviaje,
        }));
        if (!this.expense.maestroGasto && this.maestroGasto.length > 0) {
          this.expense.maestroGasto = this.maestroGasto[0].id;
          if (this.expense.maestroGasto) {
            this.addGasto();
          }
        }
      } catch (err) {
        console.error('Error obteniendo los gastos#', err);
        window.location.reload();
      }
    },
    onGastoSearch(search) {
      this.fecthGastos(search);
    },
    async fecthCurrency(query = '') {
      try {
        const response = await selectMonedas(query);
        this.monedas = response.data.map(moneda => ({
          id: moneda.id,
          nombreMoneda: moneda.nombremoneda
        }));
      } catch (err) {
        console.error('Error obteniendo las monedas', err);
      }
    },
    onCurrencySearch(search) {
      this.fecthCurrency(search);
    },
    async fecthPaymentMeans(query = '') {
      try {
        const response = await selectMediosPago(query);
        this.mediosPago = response.data.map(medioPago => ({id: medioPago.id, nombre: medioPago.nombre}));
      } catch (err) {
        console.error('Error obteniendo los medios de pago', err);
      }
    },
    onPaymentMeansSearch(search) {
      this.fecthPaymentMeans(search);
    },
    async fecthTransportMeans(query = '') {
      try {
        const response = await selectMediosTransporte(query);
        this.mediosTransporte = response.data.map(medioTransporte => ({id: medioTransporte.id, nombre: medioTransporte.nombre}));
      } catch (err) {
        console.error('Error obteniendo los medios de pago', err);
      }
    },
    onTransportMeansSearch(search) {
      this.fecthTransportMeans(search);
    },
  },
};
</script>